
const urlParams = {
    protocol:'https',
    ip:'jgf-server.alliames.app.br',
}
 
/*const urlParams = {
    protocol:'http',
    ip:'34.204.250.212:3338',
}*/

export default urlParams;








